//
// Login:
//

export const index = {
    path   : '/user_roles/',
    method : 'GET',
    version: '/v1'
}

export const getItem = {
  path   : '/user_roles/:user_roles_id/',
  method : 'GET',
  version: '/v1'
}

export const addItem = {
  path   : '/user_roles/',
  method : 'POST',
  version: '/v1'
}

export const updateItem = {
  path   : '/user_roles/:user_roles_id/',
  method : 'POST',
  version: '/v1'
}

export const deleteItem = {
  path   : '/user_roles/:user_roles_id/',
  method : 'DELETE',
  version: '/v1'
}
